export const isDevAdminEnabled = (): boolean =>
    process.env.NODE_ENV !== 'production' &&
    process.env.REACT_APP_DEV_ADMIN === 'true';

export const isFirebaseConfigured = (): boolean =>
    Boolean(
        process.env.REACT_APP_FIREBASE_API_KEY &&
        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN &&
        process.env.REACT_APP_FIREBASE_PROJECT_ID &&
        process.env.REACT_APP_FIREBASE_APP_ID
    );

export type UserRole = 'admin' | 'owner';

export const isAdminEmail = (email: string | null | undefined): boolean => {
    if (!email) {
        return false;
    }

    const allowlist = (process.env.REACT_APP_ADMIN_EMAILS || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);

    return allowlist.includes(email.toLowerCase());
};

export const ADMIN_GOOGLE_REQUIRED_MESSAGE =
    'Admin access requires a verified Google account.';

type AuthUserLike = {
    email?: string | null;
    emailVerified?: boolean;
    providerData?: Array<{ providerId?: string }>;
};

export const isVerifiedGoogleAdmin = (user: AuthUserLike | null | undefined): boolean =>
    Boolean(
        user?.email &&
        user.emailVerified &&
        isAdminEmail(user.email) &&
        (user.providerData || []).some((provider) => provider.providerId === 'google.com')
    );

export type IdTokenClaims = {
    email?: string | null;
    email_verified?: boolean;
    firebase?: { sign_in_provider?: string };
};

export const isVerifiedGoogleAdminToken = (
    decoded: IdTokenClaims | null | undefined,
    allowlist: string[]
): boolean =>
    Boolean(
        decoded?.email_verified &&
            decoded.firebase?.sign_in_provider === 'google.com' &&
            decoded.email &&
            allowlist.includes(String(decoded.email).toLowerCase())
    );
